import type { RefObject } from 'react';
import React from 'react';

const TableBuilderAgGridChartView = ({
  localChartId,
  chartWrapperRef,
  showChartView,
}: {
  localChartId: string;
  chartWrapperRef: RefObject<HTMLDivElement | null>;
  showChartView: boolean;
}) => {
  return showChartView ? (
    <div
      ref={chartWrapperRef}
      id={localChartId}
      data-testid="tableChartView"
      className="ag-theme-quartz height-maximum pb5 screenshotSizeToContent tableChartWrapper"
    />
  ) : null;
};

export default TableBuilderAgGridChartView;
